// Resolve the API origin defensively.
// In some production deployments the REACT_APP_BACKEND_URL env may differ from
// the page's actual origin only by a "www." prefix (e.g. www.example.com vs
// example.com). Cross-origin auth then breaks because Cloudflare/CDN 308-redirects
// www → bare, and browsers refuse to follow redirects on CORS preflight.
//
// To self-heal: if the env URL and window.location.origin point to the same
// registered domain (after stripping a leading "www."), use the page's origin
// so every request is same-origin. Otherwise honour REACT_APP_BACKEND_URL.
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

function stripWww(host) {
  return host.replace(/^www\./i, "");
}

function resolveApiOrigin() {
  if (typeof window === "undefined") return ENV_URL;
  if (!ENV_URL) return window.location.origin;
  try {
    const envHost = new URL(ENV_URL).host;
    const pageHost = window.location.host;
    if (envHost !== pageHost && stripWww(envHost) === stripWww(pageHost)) {
      // Same registered domain, only www differs → use the page's exact origin
      // so cookies & CORS stay first-party.
      // eslint-disable-next-line no-console
      console.warn(
        `[apiBase] REACT_APP_BACKEND_URL (${envHost}) differs from page host (${pageHost}) only by www; using ${window.location.origin} for API to keep requests same-origin.`
      );
      return window.location.origin;
    }
  } catch {
    /* malformed env URL — fall through */
  }
  return ENV_URL;
}

export const API_ORIGIN = resolveApiOrigin();
export const API = `${API_ORIGIN}/api`;
